import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsappFab } from "@/components/WhatsappFab";
import { Hero } from "@/components/sections/Hero";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { Amenities } from "@/components/sections/Amenities";
import { Rooms } from "@/components/sections/Rooms";
import { Gallery } from "@/components/sections/Gallery";
import { VirtualTour } from "@/components/sections/VirtualTour";
import { Location } from "@/components/sections/Location";
import { Requirements } from "@/components/sections/Requirements";
import { Rules } from "@/components/sections/Rules";
import { Faq } from "@/components/sections/Faq";
import { FinalCta } from "@/components/sections/FinalCta";
import { Contact } from "@/components/sections/Contact";

export const Landing = () => (
  <div className="bg-linen">
    <Navbar />
    <main>
      <Hero />
      <WhyChoose />
      <Amenities />
      <Rooms />
      <Gallery />
      <VirtualTour />
      <Location />
      <Requirements />
      <Rules />
      <Faq />
      <FinalCta />
      <Contact />
    </main>
    <Footer />
    <WhatsappFab />
  </div>
);
